import { render, staticRenderFns } from "./create-user-document.vue?vue&type=template&id=4b8c46d5&scoped=true&"
import script from "./create-user-document.vue?vue&type=script&lang=js&"
export * from "./create-user-document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8c46d5",
  null
  
)

export default component.exports